import { MailCheck } from 'lucide-react'
import { Button, Modal } from '@/components/ui'

export interface InvitationSentModalProps {
  open: boolean
  email: string
  onClose: () => void
}

export function InvitationSentModal({
  open,
  email,
  onClose,
}: InvitationSentModalProps): React.ReactElement {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="User created"
      className="max-w-md"
      footer={
        <Button type="button" onClick={onClose}>
          Done
        </Button>
      }
    >
      <div className="space-y-4">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <MailCheck className="h-5 w-5" aria-hidden />
        </div>
        <div className="space-y-2">
          <p className="text-sm text-gray-700 dark:text-gray-300">
            A password setup email has been sent to <strong>{email}</strong>.
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            The user can open the secure link in that email to choose their password and sign in.
          </p>
        </div>
      </div>
    </Modal>
  )
}

InvitationSentModal.displayName = 'InvitationSentModal'
